import { render, staticRenderFns } from "./products-chooser.vue?vue&type=template&id=0b318c17"
import script from "./products-chooser.vue?vue&type=script&lang=js"
export * from "./products-chooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports